function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, Array, JSON, Number, Object, String, open, responseText, score, submittedScore, surveyId) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("mp-modal", {
        "attrs": __vjadeStringifyAttrsIfObj({
          'closeable': true,
          'modal-type': `popup`,
          'not-fullscreen': true,
          'open': open,
        }),
        "on": {
          change: $helpers.handleModalChange
        },
        "class": Object.assign({}, {
          'nps-survey-score-screen': !submittedScore,
          'nps-survey-text-screen': submittedScore,
        }, {
          'nps-survey-root': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": Object.assign({}, {
            'nps-survey-score-screen': !submittedScore,
            'nps-survey-text-screen': submittedScore,
          }, {
            'nps-survey-content': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((!submittedScore) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'nps-survey-header': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("How likely are you to recommend Mixpanel to a friend or colleague?");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'nps-survey-scores': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = ($helpers.getScores());
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, score, $index) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "on": {
                          click: () => $helpers.handleClickScore(score)
                        },
                        "class": {
                          'nps-survey-score-button': true
                        },
                      }, [__vjadeSafeCode(score)]));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var $index = $$objKey;
                      if ($$obj.hasOwnProperty($index)) {
                        $$iterated = true;
                        var score = $$obj[$index];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "on": {
                              click: () => $helpers.handleClickScore(score)
                            },
                            "class": {
                              'nps-survey-score-button': true
                            },
                          }, [__vjadeSafeCode(score)]));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'nps-survey-likeliness': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("span", (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Not at all likely");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("span", (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Extremely likely");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'nps-survey-header': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Thank you! Your feedback has been sent.");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'nps-survey-question': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("span", {
                "class": {
                  'nps-survey-text': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("We read every single response. Why did you rate Mixpanel a " + (score) + "?");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'nps-survey-response-text-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-input", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  type: `textarea`,
                  autofocus: true,
                  value: responseText,
                }),
                "on": {
                  input: $helpers.handleTextInput,
                },
                "class": {
                  'nps-survey-response-text': true
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'nps-survey-button-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "on": {
                  click: $helpers.handleClickDismiss
                },
                "class": {
                  'nps-survey-dismiss-button': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Dismiss");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `primary`,
                  disabled: !Number.isInteger(surveyId),
                }),
                "on": {
                  click: $helpers.handleClickSubmit
                },
                "class": {
                  'nps-survey-submit-button': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Submit");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Number" in locals ? locals.Number : typeof Number !== "undefined" ? Number : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "open" in locals ? locals.open : typeof open !== "undefined" ? open : undefined, "responseText" in locals ? locals.responseText : typeof responseText !== "undefined" ? responseText : undefined, "score" in locals ? locals.score : typeof score !== "undefined" ? score : undefined, "submittedScore" in locals ? locals.submittedScore : typeof submittedScore !== "undefined" ? submittedScore : undefined, "surveyId" in locals ? locals.surveyId : typeof surveyId !== "undefined" ? surveyId : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;